var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Prop, Watch, Component } from 'vue-property-decorator';
import CategoryService from '../../../api/CategoryService';
var LeftTree = (function (_super) {
    __extends(LeftTree, _super);
    function LeftTree() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.filterText = "";
        _this.defaultProps = {
            label: 'goods_type_name',
            id: "goods_type_id"
        };
        return _this;
    }
    LeftTree.prototype.watchFilter = function (val) {
        this.$refs.tree.filter(val);
    };
    LeftTree.prototype.watchData = function (val, oldVal) {
        var _this = this;
        if (this.data && this.data.length && !oldVal.length) {
            this.$nextTick(function () {
                _this.$refs.tree.setCurrentKey(_this.data[0].children[0].goods_type_id);
                _this.$emit('node-click', _this.$refs.tree.getCurrentNode());
            });
        }
    };
    LeftTree.prototype.created = function () {
        this.service = CategoryService.getInstance();
    };
    LeftTree.prototype.mounted = function () {
        var height = document.documentElement.clientHeight - 226;
        this.$refs.tree.$el.style.maxHeight = height + 'px';
    };
    LeftTree.prototype.filterNode = function (value, data) {
        if (!value)
            return true;
        return data.goods_type_name.indexOf(value) !== -1;
    };
    LeftTree.prototype.nodeClick = function (data, node, target) {
        data.account_val_times = 0;
        this.$emit('node-click', data);
    };
    __decorate([
        Prop({
            type: Array,
            default: []
        })
    ], LeftTree.prototype, "data", void 0);
    __decorate([
        Prop({
            default: '',
            type: String
        })
    ], LeftTree.prototype, "defaultIconUrl", void 0);
    __decorate([
        Watch("filterText")
    ], LeftTree.prototype, "watchFilter", null);
    __decorate([
        Watch("data")
    ], LeftTree.prototype, "watchData", null);
    LeftTree = __decorate([
        Component
    ], LeftTree);
    return LeftTree;
}(Vue));
export default LeftTree;
